
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/country-statistics",
      function () {
        return require("private-next-pages/country-statistics.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/country-statistics"])
      });
    }
  